import { Core, IPlugin } from 'trtc-js-sdk-core/src/plugin';
import {
  BASIC_TYPE,
  MediaType,
  ValidateRule,
  VideoCodecPipelineType
} from 'trtc-js-sdk-core';
import { decodeSEI, encodeSEI, SEI_MESSAGE } from 'trtc-js-sdk-core/src/utils/codec-pipeline/sei-utils';
import { TRTCStreamType, UpdateSEIOptions } from '../type';
import { TRTCEvent } from '../trtc-event';
import { IS_INSERTABLE_STREAM_SUPPORTED } from 'trtc-js-sdk-core/src/common/rtc-detection';
import { VideoDecodeProcessorParam, VideoEncodeProcessorParam } from 'trtc-js-sdk-core/src/manager/video-manager';

// [seiPayloadType, arraybuffer]

let seiSeq = 0;
export class SEIPlugin implements IPlugin {
  static autoStart = true;
  log: Core['log'];
  private _seiMessageList: SEI_MESSAGE[] = [];
  private _smallSeiMessageList: SEI_MESSAGE[] = [];
  private _subStreamSeiMessageList: SEI_MESSAGE[] = [];
  constructor(public core: Core) {
    seiSeq++;
    this.log = core.log.createChild({ id: `${this.getAlias()}${seiSeq}` });
    this.log.info(`[sei] created id=${this.getAlias()}${seiSeq}`);

    this.encode = this.encode.bind(this);
    this.decode = this.decode.bind(this);
  }

  encode({ frame, mediaType }: VideoEncodeProcessorParam) {
    try {
      const seiMessageList = mediaType === MediaType.SMALL_VIDEO ? this._smallSeiMessageList : mediaType === MediaType.AUX_VIDEO ? this._subStreamSeiMessageList : this._seiMessageList;
      return encodeSEI({ frame, seiMessageList });
    } catch (error) {
      this.log.warn(error);
    }
    return frame;
  }
  decode({ frame, track }: VideoDecodeProcessorParam) {
    return decodeSEI({ frame, onSEI: naluList => {
      naluList.forEach(nalu => {
        if (track?.userId) {
          this.core.trtc.emit(TRTCEvent.SEI_MESSAGE, {
            seiPayloadType: nalu.seiPayloadType!,
            data: nalu.seiPayload!.buffer,
            userId: track.userId,
            streamType: track.mediaType === MediaType.AUX_VIDEO ? TRTCStreamType.Sub : TRTCStreamType.Main
          });
        } else {
          this.core.innerEmitter.emit(this.core.INNER_EVENT.SEI_MESSAGE, { room: this.core.room, nalu });
        }
      });
    } });
  }
  destroy() {
    this.log.debug('destroy');
    this.stop();
    // @ts-ignore
    delete this.core;
  }

  getValidateRule(method: 'start' | 'update' | 'stop'): ValidateRule | ValidateRule[] {
    switch (method) {
      case 'start':
        return  {
          type: BASIC_TYPE.Object
        };
      case 'update':
        return  {
          type: BASIC_TYPE.Object
        };
      case 'stop':
        return  {
          type: BASIC_TYPE.Object
        };
    }
  }

  start(): void {
    this.core.room.videoManager.addEncodeProcessor({
      processor: IS_INSERTABLE_STREAM_SUPPORTED ? this.encode : encodeSEI,
      type: VideoCodecPipelineType.SEI
    });
    this.core.room.videoManager.addDecodeProcessor({
      processor: IS_INSERTABLE_STREAM_SUPPORTED ? this.decode : decodeSEI,
      type: VideoCodecPipelineType.SEI
    });
  }

  stop(): void {
    this.core.room.videoManager.removeEncodeProcessor({ type: VideoCodecPipelineType.SEI });
    this.core.room.videoManager.removeDecodeProcessor({ type: VideoCodecPipelineType.SEI });
  }

  update({ buffer, options }: UpdateSEIOptions): void {
    const seiMessage: SEI_MESSAGE = [options.seiPayloadType, buffer];
    const small = !!options.small;
    if (options.toSubStream) {
      this._subStreamSeiMessageList.push(seiMessage);
    } else {
      this._seiMessageList.push(seiMessage);
      if (small) {
        this._smallSeiMessageList.push(seiMessage);
      }
    }
    this.core.room.scriptTransformWorker?.postMessage({ type: 'sei', data: seiMessage, isMain: !options.toSubStream, small });
  }

  static Name = 'SEI';
  getName() {
    return SEIPlugin.Name;
  }

  getAlias(): string {
    return 'sei';
  }

  getGroup(): string {
    return 'sei';
  }
}
